import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/button';
import { MODULES } from '../lib/modules';

export function NoAccess({ module }) {
  const navigate = useNavigate();
  const label = MODULES.find((m) => m.key === module)?.label || 'this area';
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center p-8 text-center" data-testid="no-access-page">
      <div className="mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-[hsl(var(--warning)/0.12)]">
        <ShieldAlert size={30} className="text-[hsl(var(--warning))]" />
      </div>
      <h1 className="font-display text-2xl font-bold">No access</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        Your access group does not permit viewing <span className="font-medium text-foreground">{label}</span>.
        Contact your administrator if you believe this is a mistake.
      </p>
      <Button className="mt-6" data-testid="no-access-home" onClick={() => navigate('/')}>Back to Dashboard</Button>
    </div>
  );
}

export default NoAccess;
